<template>
  <v-layout column pa-0 ma-0>
    <div v-if="!isSingleServiceSelected">
      <div class="text-field my-2">
        <span
          @focus="inFocus=true"
          @focusout="inFocus=false"
          style="outline:none;"
          class="body-1"
          contenteditable="true"
          @input="updateBeforeText"
        >
          {{ displayBeforeText }}
        </span>
        <span class="blue--text body-1">&lt;{{ $t('message.service') }}&gt;</span>
        <span
          @focus="inFocus=true"
          @focusout="inFocus=false"
          style="outline:none;"
          class="body-1"
          contenteditable="true"
          @input="updateAfterText"
        >
          {{ displayAfterText }}
        </span>
      </div>
      <v-divider :class="inFocus ? 'divider-select' : 'divider'" class="my-2" />
      <v-layout row sm12>
        <v-flex class="grey--text caption">
          {{ `Ex: ${hint}` }}
        </v-flex>
        <p class="grow counter grey--text caption text-right">
          {{ counterLength }}&nbsp;/&nbsp;90
        </p>
      </v-layout>
    </div>
    <custom-text-area
      v-else
      v-model="singleServiceDescription"
      :name="'descriptions'"
      :counter="90"
      :maxlength="90"
      :validation="'required'"
      :auto-grow="true"
      :rows="'1'"
      :classes="'body-1'"
      :icon="isShortenFlow ? 'mdi-check' : ''"
    />
  </v-layout>
</template>
<script>
import {
  VLayout,
  VFlex,
  VDivider
} from 'vuetify/lib';
import { mapGetters } from 'vuex';
import { businessDetailsMacros } from 'Features/bizgainOnboarding/constants';
import CustomTextArea from '../../../../../components/Input/CustomTextArea.vue';
export default {
  props: {
    description: {
      type: Object,
      default: null
    },
    isSingleServiceSelected: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return  {
      inFocus: false,
      description1BeforeService: '',
      description1AfterService: '',
      displayBeforeText: '',
      displayAfterText: '',
      service: null,
      businessDetailsMacros,
      singleServiceDescription: null
    }
  },
  created() {
    this.service = this.businessDetails.creativeDetail.promoteServices[0];
    if (this.description.value.includes(this.businessDetailsMacros.services)) {
      var texts = this.description.value.split(this.businessDetailsMacros.services)
      this.description1BeforeService = texts[0];
      this.description1AfterService = texts[1];
      this.displayBeforeText = texts[0];
      this.displayAfterText = texts[1];
      this.singleServiceDescription = `${this.displayBeforeText}${this.service}${this.displayAfterText}`;
    } else {
      this.singleServiceDescription = this.description.value;
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'roimaticConfiguration']),
    hint() {
      return `${this.description1BeforeService}${this.service}${this.description1AfterService}`;
    },
    counterLength(){
      return (this.description1BeforeService && this.description1BeforeService.length) + (this.description1AfterService && this.description1AfterService.length);
    },
    isShortenFlow(){
      if(this.businessDetails && this.businessDetails.shortenFlow){
        return true;
      }
      else if(this.roimaticConfiguration && this.roimaticConfiguration.shortenFlow){
        return true;
      }
      return false;
    }
  },
  methods: {
    updateBeforeText(event) {
      this.description1BeforeService = event.target.innerText
      this.$emit('update', { name: this.description.name, value: event.target.innerText + this.businessDetailsMacros.services + this.description1AfterService });
    },
    updateAfterText(event) {
      this.description1AfterService = event.target.innerText
      this.$emit('update', { name: this.description.name, value: this.description1BeforeService + this.businessDetailsMacros.services + event.target.innerText });
    },
    updateDescription(){
      this.$emit('update', { name: this.description.name, value: this.singleServiceDescription });
    }
  },
  watch: {
    singleServiceDescription(value){
      this.updateDescription();
    }
  },
  components: {
    VLayout,
    VFlex,
    VDivider,
    CustomTextArea
  }
}
</script>
<style scoped>

.divider:hover{
  border-color: rgba(0,0,0,0.87) !important;
}
.divider-select {
  border-color: var(--v-primary-base) !important;
  border-width: thin 0 thin 0 !important;
}
.divider {
  border-style: solid;
  border-width: thin 0 0 0;
  border-color: rgba(0, 0, 0, 0.42) !important;
}
.text-field{
  word-break: break-word;
}
</style>
